import theme from 'config/theme';

export default {
  container: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${theme.palette.grays?.gray100} !important`,
    },
    '&.Mui-focused': {
      backgroundColor: `${theme.palette.grays?.gray100} !important`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    overflow: 'hidden',
  },
  vehicleName: {
    fontWeight: 700,
    fontSize: '14px',
    color: theme.palette.grays.gray600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  detailsRow: {
    display: 'flex',
    gap: '4px',
    fontSize: '14px',
    color: theme.palette.grays.gray600,
    wordBreak: 'break-word',
    flexWrap: 'wrap',
  },
  statusBadge: (statusColor) => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '32px',
    border: `1px solid ${statusColor.border}`,
    backgroundColor: 'white',
    flexShrink: 0,
  }),
  statusDot: (statusColor) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: statusColor.dot,
  }),
  statusText: (statusColor) => ({
    fontSize: '12px',
    color: statusColor.color,
    whiteSpace: 'nowrap',
  }),
};
